@if (!isLoaded) {
  <mat-progress-bar fxFlex="100" mode="indeterminate"></mat-progress-bar>
}

@if (isLoaded) {
  <div fxFlex="100" fxLayout="row">
    <div fxFlex="35">
      <fund-recap-row [header]="true"></fund-recap-row>
      <mat-divider></mat-divider>
      @for (fund of funds; track fund) {
        <fund-recap-row [fund]="fund">
        </fund-recap-row>
      }
    </div>
    <div fxFlex="20">&nbsp;</div>
    <div fxFlex="40" fxLayout="column">
      <fund-total-chart [funds]="funds" [id]="id">
      </fund-total-chart>
    </div>
  </div>
}
